/* eslint-disable import/prefer-default-export */
export const formatDecimal = (value) => {
  if (!value) return 'N/D';
  return `${value.toFixed(2)?.replace('.', ',')}%`;
};
